import script from "./location-tag.vue?vue&type=script&setup=true&lang=js"
export * from "./location-tag.vue?vue&type=script&setup=true&lang=js"

import "./location-tag.vue?vue&type=style&index=0&id=8a60f852&scoped=true&lang=css"

import exportComponent from "/Users/timtsang/VueProject/test-2-2/test-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a60f852"]])

export default __exports__